import { Dispatch, SetStateAction, useState } from 'react';

export const useSearch = (): UseSearchReturnType => {
  const [searchText, setSearchText] = useState('');
  const searchBy = <T, K extends keyof T>(item: T, searchBy: K) => {
    if (typeof item[searchBy] === 'string') {
      return (item[searchBy] + '').toLocaleLowerCase().includes(searchText.toLocaleLowerCase());
    }
    return false;
  };
  return {
    searchText,
    setSearchText,
    searchBy,
  };
};

type UseSearchReturnType = {
  searchText: string;
  setSearchText: Dispatch<SetStateAction<string>>;
  searchBy: <T, K extends keyof T>(item: T, searchBy: K) => boolean;
};
